
  <div class="content-wrap">
    <div class="content">
      <div class="info-wrap">
        <img
          class="avtor"
          :src="$store.getters.getUser?.avatar"
          alt=""
        />
        <div class="text-wrap">
          <p>齐鲁文化参赛者 {{ user?.nickName }} </p>
          <!-- <p>最快用时 12″88</p> -->
        </div>
      </div>
      <div class="rank-info">
        <p class="flex"><span>答对题数 {{ user?.rightCount }} 题</span><span>通关次数 {{ user?.completeTime || 0 }} 次</span></p>
        <p><span>当前排名 {{ user?.rowNum }} 名</span></p>
      </div>
      <Form class="form-wrap" @submit="onSubmit">
        <CellGroup inset>
          <Field v-model="form.name" label="姓名：" placeholder="姓名" />
          <Field
            v-model="form.mobile"
            type="mobile"
            name="手机号"
            label="手机号："
            placeholder="手机号"
          />
          <Field
            v-model="form.address"
            type="address"
            name="收货地址"
            label="收货地址："
            placeholder="收货地址"
          />
        </CellGroup>
        <p class="tips">
          *中奖后将按照填写信息发送奖励，请填写真实信息
          赛事很激烈，通关时长挤进前500才赢取大奖哦！
        </p>
        <Button class="btn" native-type="submit">
          提交
        </Button>
        <div @click="$emit('close')" class="cancel-btn">取消</div>
      </Form>
    </div>
  </div>
